import Model from "./base/model";

class Billing extends Model{
  resourceName() {
    return "billings";
  }

  fields() {
    return {
      expire_at: "",
      paid: "",
      paid_at: "",
      billing_plan_values :{jsonApi: "hasMany", type:"billing_plan_values"},
      created_at: "",
      closed_at: "",
      expired: "",
      total: "",
      billing_extra_plan_values :{jsonApi: "hasMany", type:"billing_extra_plan_values"},
      company: {jsonApi: "hasOne", type:"companies"},
      is_annual_plan: "",
      contracted_price: {jsonApi: "hasOne", type:"billing_contracted_prices"},
      additionals: {jsonApi: "hasMany", type:"billing_contracted_price_additionals"},
    }
  }

  async setBillingAsPaid(id) {
    return this.request(
      this.resourceName() + "/" + id,
      "POST",
      {},
      {},
    );
  }
}

export default new Billing();
